export const tabToNextSiblingElement = (): void => tabToSiblingElement(1);
export const tabToPreviousSiblingElement = (): void => tabToSiblingElement(-1);

export const tabToSiblingElement = (direction: 1 | -1): void => {
  const active = document.activeElement as HTMLElement | null;
  if (!active) {
    return;
  }

  const selector = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]',
  ].join(',');

  const focusables = Array.from(active.parentElement?.querySelectorAll<HTMLElement>(selector) ?? []).filter(
    (el) => el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden',
  );

  const next = focusables.indexOf(active) + direction;

  if (next >= 0 && next < focusables.length) {
    focusables[next]?.focus();
  }
};
